import { FC, useEffect, useRef, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik'
import { Adapter, AnnounceService, AnnouncementRequestDto, AnnouncementTypeEnum, CommonService, IFormAnnouncement, Pattern, SeasonDto } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormCheckBox, FormDataPicker, FormInputNumber, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'
import { FormDropZoneUpload } from 'app/components/formInputs/FormDropZoneUpload'
import { FormTextEditor } from 'app/components/formInputs/FormTextEditor'
import { ModalBox } from 'app/components/modals/ModalBox'


type Props = {

}

export const AnnouceSettingEditPage: FC<Props> = () => {

  const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
  let initValue: IFormAnnouncement = {
    seasonId: lastSeason.id ?? 0,
    title: '',
    description: '',
    status: 'New',
    point: 0,
    expiredDate: new Date(),
    isActive: true,
    announcementFiles: [],
    announceQuestions: [],
    type: AnnouncementTypeEnum[AnnouncementTypeEnum.Acknowledge],
    isRead: false,
    id: 0,
    createdDate: new Date(),
    isShowModel: false

  }
  const formSchema = Yup.object().shape({
    seasonId: Yup.number().required('require'),
    title: Yup.string().required('require'),
    //description: Yup.string().required('require'),
    //point: Yup.number().min(1, 'more than zero').required('require'),
    isActive: Yup.boolean().required('require'),
    // code: Yup.string().required('require'),
  })



  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<IFormAnnouncement>(initValue)
  const [seasonMonth, setSeasonMonth] = useState<string>(moment(new Date()).format("YYYY-MMM-01"))
  //const [showModal, setShowModal] = useState<boolean>(false)
  //const [qaData, setQAData] = useState<IFormQuestionAnswerItem[]>([])

  const refQ = useRef<HTMLTextAreaElement>(null)
  const refA = useRef<HTMLTextAreaElement>(null)

  const { id } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    const init = () => {
      if (id && id !== 'new') {

        AnnounceService.GetById(Number(id)).then((result) => {
          const res = result.data.result
          if (res) {
            const frmDto = Adapter.FormAnnouncement(res);
            setData(frmDto)
          }

        })
      }
      setLoading(false)
    }
    init()
  }, [id])

  const onSubmit = async (values: IFormAnnouncement) => {
    setLoading(true)
    const updatedData = Adapter.mapAnnouncement(values)
    //debugger
    if (values.announcementFiles.length > 0) {
      const fileToUpload = values.announcementFiles.filter(x => !x.frmDb).map((x) => x.file!)
      try {
        const uploaded = await CommonService.uploadFiles('img-announce', fileToUpload)
        uploaded.data.result.forEach((file) =>
          updatedData.announcementFiles.push({
            fileName: file.fileName,
            originalFileName: file.originalFileName,
            isNew: true,
          })
        )
      } catch (ex) {
        toast.error(catchErrorMsg(ex))
        setLoading(false)
        return;
      }

    }

    if (id && id === 'new') {
      Save(updatedData)
    } else if (id) {
      Update(Number(id), updatedData)
    }


  }

  const Save = (updatedData: AnnouncementRequestDto) => {

    AnnounceService.Create(updatedData)
      .then((res) => {
        toast.success('Save Success.')
        setLoading(false)
        navigate('/setting/announce')
      }).catch((res) => {
        toast.error(catchErrorMsg(res))
        setLoading(false)
      })
  }

  const Update = (id: number, updatedData: AnnouncementRequestDto) => {
    AnnounceService.Update(id, updatedData).then(() => {
      toast.success('Update Success.')
      setLoading(false)
      navigate('/setting/announce')
    }).catch((res) => {
      toast.error(catchErrorMsg(res))
      setLoading(false)
    })
  }



  const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
    const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
    const inputCls = props.inputCls ?? 'col-lg-6'
    return (
      <div className='row mb-7'>
        <label className={labelCls}>{props.lable}</label>
        <div className={inputCls}>
          <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

        </div>
        {props.textEnd && <div className={props.txtEndCls}>
          <span > {props.textEnd}</span>
        </div>}
      </div>
    )
  }


  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'ประกาศ',
            path: '/announce',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        ประกาศ
      </PageTitle>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0 '>
            <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
            <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
          </div>
        </div>
        <Formik
          enableReinitialize
          initialValues={data}
          validationSchema={formSchema}
          onSubmit={onSubmit}
          validate={(val) => console.log(val)}
        >
          {({ values, handleSubmit, setFieldValue, errors, touched }) => (
            <Form>
              <>
                {/* begin::Scroll */}
                <div className='card-body p-9'>
                  <CellStyle lable='วันหมดอายุ'>
                    <Field
                      name='expiredDate'
                      className={
                        'form-control form-control-solid' +
                        (errors.expiredDate && touched.expiredDate ? ' is-invalid' : '')
                      }
                      value={moment(values.expiredDate).format('DD/MM/YYYY')}
                      onDateChange={(value: Date, e: any) => {
                        setFieldValue('expiredDate', value)
                      }}
                      minDate={new Date()}
                      component={FormDataPicker}
                    />
                    <ErrorMessage name={`expiredDate`} component='div' className='text-danger' />
                  </CellStyle>
                  <CellStyle lable='หัวข้อ'  >
                    <Field
                      name='title'
                      className={
                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                        (errors.title && touched.title ? ' is-invalid' : '')
                      }
                    />
                    <ErrorMessage name={`title`} component='div' className='text-danger' />
                  </CellStyle>
                  <CellStyle lable='คำถาม / รายละเอียด'>
                    {/* <Field
                      as='textarea'
                      autoComplete='off'
                      name='description'
                      className={
                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                        (errors.description && touched.description ? ' is-invalid' : '')
                      }
                      rows={8}
                    /> */}
                    <Field
                      name='description'
                      className={
                        'form-control form-control-lg  mb-3 mb-lg-0' +
                        (errors.description && touched.description ? ' is-invalid' : '')
                      }
                      component={FormTextEditor}
                    />
                    <ErrorMessage name={`description`} component='div' className='text-danger' />
                  </CellStyle>
                  <CellStyle lable='คะแนน' inputCls='col-lg-2' txtEndCls='col-lg-2'>
                    <Field
                      name='point'
                      className={
                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                        (errors.point && touched.point ? ' is-invalid' : '')
                      }
                      maxLength={18}
                      pattern={Pattern.Number2Digit}
                      component={FormInputNumber}
                    />
                    <ErrorMessage name={`point`} component='div' className='text-danger' />
                  </CellStyle>

                  <CellStyle lable='Upload file'>
                    <Field
                      name='announcementFiles'
                      maxFiles={5}
                      component={FormDropZoneUpload}
                    />
                  </CellStyle>
                  <CellStyle lable='ประเภท' inputCls='col-lg-4' txtEndCls='col-lg-2'>
                    <div className='d-flex justify-content-between'>
                      <Field
                        label={'รับทราบ'}
                        name={`type`}
                        gName={`type`}
                        gValue={'Acknowledge'}
                        component={FormRadio}
                      />

                      <Field
                        label={'ถามตอบ'}
                        name={`type`}
                        gName={`type`}
                        gValue={'Question'}
                        component={FormRadio}
                      />
                      <button className='btn btn-sm btn-secondary' disabled={values.type === AnnouncementTypeEnum[AnnouncementTypeEnum.Acknowledge]} onClick={(e) => {
                        e.preventDefault()
                        setFieldValue('isShowModel', true)
                      }}>บันทึกคำ ถาม/ตอบ</button>
                    </div>
                  </CellStyle>

                  <CellStyle lable='สถานะ'>
                    <Field

                      name='isActive'
                      className={
                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                        (errors.isActive && touched.isActive ? ' is-invalid' : '')
                      }
                      component={FormCheckBox}
                    />
                    <ErrorMessage name={`isActive`} component='div' className='text-danger' />
                  </CellStyle>


                </div>
                {/* end::Scroll */}

                <div className='card-footer d-flex py-6 px-9'>
                  <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                    {!loading && 'Save Changes'}
                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>

                  <button className='btn btn-light' onClick={() => navigate('/setting/announce')}> Back</button>
                </div>
              </>
              {(
                <ModalBox
                  title={'แก้ไขการประเมินตนเอง'}
                  stateShow={values.isShowModel}
                  onHide={() => { setFieldValue('isShowModel', false) }}
                  showOK={false}
                  txtCancel='Close'
                  showCancel={true}
                >
                  <>
                    {/* begin::Scroll */}
                    <div className='card-body p-9'>
                      <div className='row py-5'>
                        <div className='col-md-12 d-flex flex-column'>
                          <label>คำถาม</label>
                          <textarea rows={5} ref={refQ} ></textarea>
                        </div>
                        <div className='col-md-12 d-flex flex-column'>
                          <label>คำตอบ</label>
                          <textarea rows={2} ref={refA} ></textarea>
                        </div>
                        <div className='col-md-12 pt-5'> <button className='btn btn-sm btn-primary' onClick={() => {
                          const question = refQ.current?.value ?? '';
                          const answer = refA.current?.value ?? '';                          
                          setFieldValue('announceQuestions', [...values.announceQuestions, { question: question, answer: answer }]) 
                        }}>บันทึกคำ ถาม/ตอบ</button></div>
                      </div>
                      <div className='row py-5'>
                        <table className='table table-striped fs-8'>
                          <thead className='table-primary'>
                            <tr>
                              <th style={{ width: '60%' }}>คำถาม</th>
                              <th>คำตอบ</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {<FieldArray name='announceQuestions'
                              render={() => {
                                return <>
                                  {values.announceQuestions && values.announceQuestions.length > 0 ? (
                                    values.announceQuestions.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{item.question}</td>
                                          <td>{item.answer}</td>
                                          <td><button onClick={() => {
                                            let newData = Object.assign([], values.announceQuestions)
                                            newData.splice(index, 1);                                            
                                            setFieldValue('announceQuestions', newData) 
                                          }} className='btn btn-sm btn-danger'>Delete</button></td>
                                        </tr>
                                      )
                                    })
                                  ) : (
                                    <></>
                                  )}
                                </>
                              }}
                            />}
                            {/* {qaData.map((item, index) => {

                              return <tr key={index}>
                                <td>{item.question}</td>
                                <td>{item.answer}</td>
                                <td><button onClick={() => {
                                  let newData = Object.assign([], qaData)
                                  newData.splice(index, 1);
                                  setQAData(newData)
                                }} className='btn btn-sm btn-danger'>Delete</button></td>
                              </tr>

                            })} */}


                          </tbody>
                        </table>

                      </div>
                    </div>
                  </>

                </ModalBox>)}
            </Form>
          )}
        </Formik>
      </div>

    </>
  )
}

